import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-30b1f5f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = {
  key: 0,
  class: "form-label text-muted"
}
const _hoisted_3 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_4 = {
  key: 0,
  class: "border border-start-0 border-end-0 d-flex align-items-center py-3"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-image text-primary display-3" }, null, -1))
const _hoisted_6 = { class: "w-100 mx-4" }
const _hoisted_7 = { class: "d-flex justify-content-between" }
const _hoisted_8 = { class: "text-primary" }
const _hoisted_9 = { class: "progress" }
const _hoisted_10 = {
  key: 0,
  class: ""
}
const _hoisted_11 = ["id", "name", "accept"]
const _hoisted_12 = {
  key: 1,
  class: "form-control-custom mb-3 text-muted"
}
const _hoisted_13 = ["id", "name", "accept"]
const _hoisted_14 = ["src", "height"]
const _hoisted_15 = {
  key: 1,
  class: "text"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "fas fa-file-image display-4 mb-3"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "h2 mb-1" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Clique ou arraste uma imagem ")
], -1))
const _hoisted_19 = ["id"]

import { computed, onMounted, ref } from "vue";
import VueCropper from "vue-cropperjs";
// @ts-ignore
import "cropperjs/dist/cropper.css";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { dataURLtoFile, toggleModal } from "@/utils/Helper";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageCropper',
  props: {
    accept: { default: "image/*,.pdf" },
    customFileInputWidth: { default: 100 },
    aspectRatio: { default: 1 },
    inputId: { default: () => `def-${new Date().getTime()}` },
    hiddenInput: { type: Boolean, default: false },
    modalId: { default: () => `${new Date().getTime()}` },
    maxImgSize: { default: 8 },
    customIcon: { default: null },
    label: { default: "" },
    required: { type: Boolean, default: false },
    backdrop: { default: "static" },
    image: { default: "" }
  },
  emits: ["cropEnd"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const cropperRef = ref<InstanceType<typeof VueCropper> | null>(null);
const fileInputRef = ref<HTMLInputElement | null>(null);

const imgSrc = ref<string | ArrayBuffer | null>(null);
const cropImg = ref(props.image);
const fileImage = ref<File | null>(null);
const percentage = ref(0);
const uploading = ref(false);
const counter = ref<ReturnType<typeof setTimeout> | null>(null);
const originalFile = ref<File | null>(null);

const modal_id = computed(() => `image-modal-${props.modalId}`);
const fileName = computed(() =>
  originalFile.value ? `${originalFile.value.name}` : ``,
);
const input_name = computed(() => `${props.inputId}-name`);
const button_id = computed(() => `${props.inputId}_button`);

onMounted(() => {
  EventBus.$on(EventBusNames.CLEAR_IMAGE_CROPPER, () => {
    imgSrc.value = null;
    cropImg.value = props.image;
    fileImage.value = null;
  });
});

const isImageSizeValid = (value: File | null, maxSizeInMb = 8): boolean => {
  if (!value) {
    return true;
  }
  return value.size / 1024 / 1024 <= maxSizeInMb;
};

const upload = () => {
  uploading.value = true;
  let timer = Math.floor(Math.random() * 500) + 500;
  percentage.value = 100;
  timer = 1;
  counter.value = setTimeout(() => {
    setCounter();
  }, timer);
};

const setCounter = () => {
  if (percentage.value < 100) {
    const max = 100;
    const p =
      Math.floor(Math.random() * (max - percentage.value + 1)) +
      percentage.value;
    percentage.value = p >= 100 ? 100 : p;
    upload();
  } else {
    uploading.value = false;
    percentage.value = 0;
    if (counter.value) {
      clearTimeout(counter.value);
    }
    const result = { file: fileImage.value, base64: cropImg.value };
    emit("cropEnd", result);
    cropClosed();
  }
};

const cropImage = () => {
  const cropper = cropperRef.value as any;
  cropImg.value = cropper.getCroppedCanvas().toDataURL();
  fileImage.value = dataURLtoFile(
    cropper.getCroppedCanvas().toDataURL("image/jpeg"),
    "text.jpeg",
  );

  if (fileImage.value.size > props.maxImgSize * 1024 * 1024) {
    fileImage.value = dataURLtoFile(
      cropper.getCroppedCanvas().toDataURL("image/jpeg", 0.7),
      "text.jpeg",
    );
  }
  toggleModal(modal_id.value);
  upload();
};

const setImage = (e: Event) => {
  const target = e.target as HTMLInputElement;
  if (target.files && target.files.length > 0) {
    originalFile.value = target.files[0];
    if (!isImageSizeValid(originalFile.value, props.maxImgSize)) {
      alert(
        `Sua imagem tem ${(originalFile.value.size / 1024 / 1024).toFixed(
          2,
        )}MB. Selecione uma imagem com no máximo ${props.maxImgSize}MB`,
      );
      return;
    }

    toggleModal(modal_id.value);

    if (originalFile.value.type.indexOf("image/") === -1) {
      alert("Por favor selecione uma imagem");
      return;
    }
    if (typeof FileReader === "function") {
      const reader = new FileReader();
      reader.onload = (event) => {
        imgSrc.value = event.target?.result ?? null;
        const cropper = cropperRef.value as any;
        cropper.replace(event.target?.result);
      };
      reader.readAsDataURL(originalFile.value);
    } else {
      alert("Sorry, FileReader API not supported");
    }
  }
};

const cancelUpload = () => {
  uploading.value = false;
  percentage.value = 0;
  cropImg.value = "";
  if (counter.value) {
    clearTimeout(counter.value);
  }
};

const cropClosed = () => {
  if (fileInputRef.value) {
    fileInputRef.value.value = "";
  }
};

return (_ctx: any,_cache: any) => {
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
            (_ctx.required)
              ? (_openBlock(), _createElementBlock("i", _hoisted_3, "*"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "labelContentEnd")
    ]),
    (uploading.value && !_ctx.hiddenInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("strong", null, _toDisplayString(fileName.value), 1),
              _createElementVNode("strong", _hoisted_8, _toDisplayString(percentage.value) + "%", 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "progress-bar",
                role: "progressbar",
                style: _normalizeStyle(`width: ${percentage.value}%`),
                "aria-valuenow": "25",
                "aria-valuemin": "0",
                "aria-valuemax": "100"
              }, null, 4)
            ])
          ]),
          _createElementVNode("i", {
            class: "fas fa-times display-4 text-light",
            onClick: cancelUpload
          })
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.hiddenInput)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("input", {
                  hidden: "",
                  id: _ctx.inputId,
                  ref_key: "fileInputRef",
                  ref: fileInputRef,
                  type: "file",
                  name: input_name.value,
                  accept: _ctx.accept,
                  onChange: setImage,
                  style: _normalizeStyle({ width: _ctx.customFileInputWidth + 'px' })
                }, null, 44, _hoisted_11)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("input", {
                  id: _ctx.inputId,
                  ref_key: "fileInputRef",
                  ref: fileInputRef,
                  type: "file",
                  name: input_name.value,
                  accept: _ctx.accept,
                  onChange: setImage,
                  style: _normalizeStyle({ width: _ctx.customFileInputWidth + 'px' })
                }, null, 44, _hoisted_13),
                (cropImg.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: cropImg.value,
                      width: "200",
                      height: _ctx.aspectRatio == 1 ? 200 : 300,
                      class: "rounded",
                      style: {"object-fit":"contain"}
                    }, null, 8, _hoisted_14))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_ctx.customIcon)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.customIcon,
                            alt: "",
                            height: "100",
                            class: "mb-3"
                          }, null, 8, _hoisted_16))
                        : (_openBlock(), _createElementBlock("i", _hoisted_17)),
                      _hoisted_18,
                      _createElementVNode("small", null, "Tamanho máximo: " + _toDisplayString(_ctx.maxImgSize) + "mb", 1)
                    ]))
              ]))
        ], 64)),
    _createVNode(_component_ModalComponent, {
      title: "Crop Imagem",
      id: modal_id.value,
      onModalClosed: cropClosed,
      backdrop: _ctx.backdrop
    }, {
      body: _withCtx(() => [
        _createVNode(_unref(VueCropper), {
          modal: false,
          movable: false,
          zoomable: false,
          ref_key: "cropperRef",
          ref: cropperRef,
          src: imgSrc.value,
          alt: "Crop Imagem",
          "aspect-ratio": _ctx.aspectRatio,
          minContainerWidth: 550,
          minContainerHeight: 350
        }, null, 8, ["src", "aspect-ratio"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          onClick: cropImage,
          class: "btn btn-secondary",
          id: button_id.value
        }, " Concluir ", 8, _hoisted_19)
      ]),
      _: 1
    }, 8, ["id", "backdrop"])
  ]))
}
}

})